import { DisplayTime } from 'common/display-state/display-time.js';
import { ListInlineIconItem } from 'common/grid-list-items/list-inline-icon-item.js';
import { HTMLRenderer, IHTMLRendererProps } from 'common/html-renderer.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { Reference } from 'common/reference/reference.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { IImageLinkCore } from 'utilities/image/image.js';
import { LinkRef } from './link-ref.js';

export type ConditionDescriptionProps = {
  condition?: [
    {
      icon?: IconNameV1;
      title: string;
      value: string;
    },
  ];
  issuedAt: string | undefined;
  attribution?: IImageLinkCore;
  html?: IHTMLRendererProps;
};

export const ConditionElements = ({
  condition,
}: {
  condition?: [
    {
      icon?: IconNameV1;
      title: string;
      value: string;
    },
  ];
}) => {
  if (condition) {
    return (
      <div className="grid-list">
        {condition.map(({ icon, title, value }) => {
          if (icon) {
            return (
              <ListInlineIconItem key={title} title={title} v={1} icon={icon}>
                <span>{value}</span>
              </ListInlineIconItem>
            );
          }
          return <span>{value}</span>;
        })}
      </div>
    );
  }
  return null;
};

export const ConditionDescription = (props: IModule<ConditionDescriptionProps>) => {
  const { attribution, link, condition, issuedAt } = props.config;

  return (
    <Tile dataModule="condition-description" {...props}>
      <div className="Tile-body">
        <ConditionElements condition={condition} />

        {issuedAt && (
          <small className="fineprint u-block u-textGrey u-mT-sm">
            Issued: <DisplayTime date={issuedAt.toString()} />
          </small>
        )}

        <HTMLRenderer {...props.config.html} classes={'u-mT-sm u-text-sm '.concat(props.config.html?.classes ?? '')} />

        {attribution && (
          <div className="u-textGrey fineprint u-mB-xs u-md-mB-sm u-pT-sm">
            <Reference image={attribution?.image} text={attribution?.text} url={attribution?.url} maxHeight={1.5} />
          </div>
        )}

        <LinkRef link={link} trackingOrigin='generic_conditions' />
      </div>
    </Tile>
  );
};
